import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getAwards = (ids) => {
  return axios.post(`${getBackendUrl()}/awards`, {ids: ids}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const assignAwardToEvent = (award) => {
  return axios.post(`${getBackendUrl()}/award/assign-to-event`, award, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getAllAwards = () => {
  return axios.get(`${getBackendUrl()}/awards/all`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addAward = (award) => {
  return axios.put(`${getBackendUrl()}/award`, award, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeAward = (id) => {
  return axios.delete(`${getBackendUrl()}/award/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const uploadAwardImage = (id, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${getBackendUrl()}/award/${id}/image`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
